<template>
  <div class="pagesize-wrapper">
    <div class="pagesize-title">{{ $t('listingPager.profilePageSize') }}:</div>
    <SprSimpleDropdown
      :items="dropdownItems"
      :value="currentPageSize.toString()"
      :pager="true"
      @input="pageSizeChanged"
    />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import SprSimpleDropdown from './SPRSimpleDropdown.vue'

export default Vue.extend({
  name: 'PageSizeSelector',
  components: { SprSimpleDropdown },
  props: {
    take: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      pageSizes: [
        { value: 5 },
        { value: 20 },
        { value: 50 },
        { value: 100 },
        { value: 150 },
      ],
      currentPageSize: 5,
    }
  },
  computed: {
    dropdownItems() {
      return this.pageSizes.map((p) => ({
        value: p.value.toString(),
        text: p.value.toString(),
      }))
    },
  },
  mounted() {
    if (!this.pageSizes.find((p) => p.value === this.take)) {
      this.pageSizes.push({ value: this.take })
    }
    this.pageSizes.sort((a, b) => a.value - b.value)
    this.currentPageSize = this.take
  },
  methods: {
    pageSizeChanged(pageSizeStr: string): void {
      const pageSize = parseInt(pageSizeStr, 10)
      this.currentPageSize = pageSize
      this.$emit('pagesizechanged', pageSize)
    },
  },
})
</script>

<style lang="scss">
/* PageSizeSelector.vue */
@import '../assets/scss/_variables.scss';
.pagesize-wrapper {
  display: flex;
  align-items: center;
  font-size: 14px;

  .pagesize-title {
    color: $brand-red;
  }
  /* Target only SprSimpleDropdown in this component */
  .spr-simple-dropdown {
    margin: 0; /* Remove form-group default margin if any */

    .form-group {
      margin-bottom: 0; /* Prevent large spacing */
      display: flex;
      align-items: center;
    }

    label {
      display: none; /* Hide the label to save space */
    }

    select.form-control {
      height: 26px;
      padding: 2px 8px;
      font-size: 13px;
      line-height: 1.2;
    }
  }
}
</style>
